import { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIcabsProductCoverList,
  selectIcabsProductDetailList,
  selectIcabsProductList,
  selectInfestationLevellList,
  selectLocationList,
  selectReqtCategoryList,
  selectPezodeUnitList,
} from "../store/store-selector";
import {
  setIcabsProductCoverList,
  setIcabsProductDetailList,
  setIcabsProductList,
  setInfestationLevelList,
  setLocationList,
  setReqtCategoryList,
  setPezodeUnitList
} from "../store/slice-index";
import { PricingPortalAPI } from "../apis/pricing-api";
import { DisplaySpinnerContext } from "../context/ContextIndex";

const usePezodeFormData = (businessCode, countryCode) => {
  const dispatch = useDispatch();
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const [pezodeFormLookupData, setPezodeLookupData] = useState({
    locationList: useSelector(selectLocationList),
    pestList: useSelector(selectReqtCategoryList),
    icabsProductList: useSelector(selectIcabsProductList),
    icabsProductDetailList: useSelector(selectIcabsProductDetailList),
    icabsProductCoverList: useSelector(selectIcabsProductCoverList),
    infestationLevelList: useSelector(selectInfestationLevellList),
    pezodeUnitList: useSelector(selectPezodeUnitList),
    zoneList: [],
    deviceList: [],
    consumableProductList: []
  });

  useEffect(() => {
    const fetchLookupData = async () => {
      try {
        let _location = pezodeFormLookupData.locationList;
        let _pest = pezodeFormLookupData.pestList;
        let _icabsProduct = pezodeFormLookupData.icabsProductList;
        let _icabsProductDetails = pezodeFormLookupData.icabsProductDetailList;
        let _icabsProductCover = pezodeFormLookupData.icabsProductCoverList;
        let _infestationLevel = pezodeFormLookupData.infestationLevelList;
        let _pezodeUnit = pezodeFormLookupData._pezodeUnit;
        let _zone = [];
        let _device = [];
        let _consumableProduct = [];

        if (!(_location && _location.length > 0)) {
          _location = await PricingPortalAPI.getList(businessCode, countryCode, "getLocationList", "location");
          _location = _location.map((item) => ({
            LocationId: item.LocationId,
            LocationName: item.LocationName,
          }));
          dispatch(setLocationList(_location));
        }
        if (!(_pest && _pest.length > 0)) {
          _pest = await PricingPortalAPI.getList(businessCode, countryCode, "getReqtCategory", "reqtcategory");
          _pest = _pest.map((item) => ({
            ReqtCategoryID: item.ReqtCategoryID,
            ReqtCategoryDesc: item.ReqtCategoryDesc,
          }));
          dispatch(setReqtCategoryList(_pest));
        }
        //  if (!(_icabsProduct && _icabsProduct.length > 0)) {
        _icabsProduct = await PricingPortalAPI.getList(businessCode, countryCode, "getIcabsProduct", "product");
        _icabsProduct = _icabsProduct.map((item) => ({
          ProductCode: item.ProductCode,
          ProductDesc: item.ProductDesc,
        }));
        dispatch(setIcabsProductList(_icabsProduct));
        //  }
        // if (!(_icabsProductDetails && _icabsProductDetails.length > 0)) {
        _icabsProductDetails = await PricingPortalAPI.getList(
          businessCode,
          countryCode,
          "getIcabsProductDetail",
          "productdetail"
        );
        _icabsProductDetails = _icabsProductDetails.map((item) => ({
          ProductDetailCode: item.ProductDetailCode,
          ProductDetailDesc: item.ProductDetailDesc,
        }));
        dispatch(setIcabsProductDetailList(_icabsProductDetails));
        //   }
        //   if (!(_icabsProductCover && _icabsProductCover.length > 0)) {
        _icabsProductCover = await PricingPortalAPI.getList(businessCode, countryCode, "getIcabsProductCover", "productcover");
        _icabsProductCover = _icabsProductCover.map((item) => ({
          ProductCode: item.ProductCode,
          ProductDetailCode: item.ProductDetailCode,
        }));
        dispatch(setIcabsProductCoverList(_icabsProductCover));
        //   }
        if (!(_infestationLevel && _infestationLevel.length > 0)) {
          _infestationLevel = await PricingPortalAPI.getList(
            businessCode,
            countryCode,
            "getInfestationLevelList",
            "infestationlevel"
          );
          _infestationLevel = _infestationLevel.map((item) => ({
            InfestationLevelId: item.InfestationLevelId,
            LevelDescription: item.LevelDescription,
          }));
          dispatch(setInfestationLevelList(_infestationLevel));
        }

        if (!(_pezodeUnit && _pezodeUnit.length > 0)) {
          _pezodeUnit = await PricingPortalAPI.getList(
            businessCode,
            countryCode,
            "getPezodeUnit",
            "pezodeunit"
          );
          _pezodeUnit = _pezodeUnit.map((item) => ({
            UnitKey: item.UnitKey,
            UnitValue: item.UnitValue,
          }));
          dispatch(setPezodeUnitList(_pezodeUnit));
        }
        _zone = await PricingPortalAPI.getFilterList(
          businessCode,
          countryCode,
          "getZoneList",
          "zonelocation",
          `&status=active`
        );

        _device = await PricingPortalAPI.getFilterList(
          businessCode,
          countryCode,
          "getDeviceList",
          "device",
          `&status=active`
        );

        _consumableProduct = await PricingPortalAPI.getFilterList(
          businessCode,
          countryCode,
          "getConsumableProductList",
          "consumableproduct",
          `&status=active`
        );


        setPezodeLookupData({
          locationList: _location,
          pestList: _pest,
          icabsProductList: _icabsProduct,
          icabsProductDetailList: _icabsProductDetails,
          infestationLevelList: _infestationLevel,
          icabsProductCoverList: _icabsProductCover,
          zoneList: _zone,
          deviceList: _device,
          pezodeUnitList: _pezodeUnit,
          consumableProductList: _consumableProduct
        });
        // spinnerCtx.setLoadingIndicator(false);
      } catch (err) {
        spinnerCtx.setLoadingIndicator(false);
        alert(err);
      }
    };
    // spinnerCtx.setLoadingIndicator(true);
    fetchLookupData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return pezodeFormLookupData;
};

export { usePezodeFormData };
